<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="CasePackage"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/CasePackage/CoreCasePackageDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.name="{ item }">
        <v-chip :color="item.color">{{ item.name }}</v-chip>
      </template>
      <template v-slot:item.dgs_status="{ item }">
        <v-icon v-if="item.dgs_status === 'success'" color="success">mdi-check-circle-outline</v-icon>
        <v-icon v-if="item.dgs_status === 'warning'" color="warning">mdi-alert-circle-outline</v-icon>
        <v-icon v-if="item.dgs_status === 'error'" color="error">mdi-alert-circle-outline</v-icon>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreCasePackageDetail from "@/components/CoreComponent/CasePackage/CoreCasePackageDetail";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";

export default {
  name: "CoreCasePackageTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'CasePackageTable'},
    dtoDetailQuery: {default: 'CasePackageDetailQueryDTO'},
    detailStoreName: {default: 'CasePackageDetail'},
    dtoValidateCommand: {type: [String], default: 'CasePackageValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'CasePackageListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CasePackageActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreCasePackageDetail,
  },

  methods: {
    async embeddedImport(input_list) {
      if (!input_list[0].value)
        return
      console.log('embeddedImport', this.$refs, input_list[0].value)
      let data = await fileFunction.getFile(input_list[0].value)
      this.aggregateStore.fetchAction({
        storeName: this.$id,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: null,
        uidSelected: [],
        actionName: 'execute_import',
        actionUid: null,
        data: data,
        callBack: null,
        callReceive: null
      })
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.aggregateStore = useAggregateStore()
    this.storeTable.dtoDetailQuery = this.dtoDetailQuery
    this.storeTable.dtoListQuery = this.dtoListQuery
    this.storeTable.dtoActionCommand = this.dtoActionCommand
    this.storeTable.options.sortBy = ['name']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'QA', value: 'check_qa_params', sortable: false, filterable: true, divider: true, type: 'bool', width: 10},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true,},
      {text: 'dgs status', value: 'dgs_status', sortable: false, divider: true, width: 30},
      {text: 'Type', value: 'case_package_type', sortable: true, divider: true, width: 60},
      {text: 'Teach complete', value: 'teach_complete_common', sortable: true, divider: true, type: 'bool', width: 30},
      {text: 'Need common XML', value: 'need_common', sortable: true, divider: true, type: 'bool', width: 30},
      {text: 'Exists common XML', value: 'exists_common_xml', sortable: false, divider: true, type: 'bool', width: 30},
      {
        text: 'Teach complete resistor',
        value: 'teach_complete_resistor',
        sortable: true,
        divider: true,
        type: 'bool',
        width: 30
      },
      {text: 'Need resistor XML', value: 'need_resistor', sortable: true, divider: true, type: 'bool', width: 30},
      {
        text: 'Exists resistor XML',
        value: 'exists_resistor_xml',
        sortable: false,
        divider: true,
        type: 'bool',
        width: 30
      },
      {
        text: 'Teach complete capacitor',
        value: 'teach_complete_capacitor',
        sortable: true,
        divider: true,
        type: 'bool',
        width: 30
      },
      {text: 'Need capacitor XML', value: 'need_capacitor', sortable: true, divider: true, type: 'bool', width: 30},
      {
        text: 'Exists capacitor XML',
        value: 'exists_capacitor_xml',
        sortable: false,
        divider: true,
        type: 'bool',
        width: 30
      },
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeTable: null,
      aggregateStore: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>